// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DateField__popup-c17c66 {
  width: 400px;
  padding-bottom: 24px;
}

.DateField__calendar-f15bbb {
  min-height: auto;
  margin-bottom: 21px;
}

.DateField__container-cb4c1e {
  min-width: 125px;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/RightSidebar/Form/DateField/DateField.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".popup {\n  width: 400px;\n  padding-bottom: 24px;\n}\n\n.calendar {\n  min-height: auto;\n  margin-bottom: 21px;\n}\n\n.container {\n  min-width: 125px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `DateField__popup-c17c66`,
	"calendar": `DateField__calendar-f15bbb`,
	"container": `DateField__container-cb4c1e`
};
module.exports = ___CSS_LOADER_EXPORT___;
